import * as React from 'react';
import type { LucideIcon } from 'lucide-react';

import { cn } from '../../../lib/utils';
import { Badge } from '../../ui/badge';

export interface StatusBadgeProps<T extends string> {
  /** Optional additional CSS classes */
  className?: string;
  /** Optional icon rendered before the label, inheriting the badge's text color */
  icon?: LucideIcon;
  /** The translated label to show inside the badge */
  label: string;
  /** The status value used to look up the style */
  status: T;
  /** A record mapping each status value to a Tailwind class string */
  styles: Record<T, string>;
  /** Optional native tooltip forwarded to the underlying element */
  title?: string;
}

export function StatusBadge<T extends string>({
  className,
  icon: Icon,
  label,
  status,
  styles,
  title,
}: StatusBadgeProps<T>): React.JSX.Element {
  return (
    <Badge
      className={cn('w-fit', Icon !== undefined && 'gap-1', styles[status], className)}
      title={title}
      variant="outline"
    >
      {Icon !== undefined && <Icon className="w-3 h-3" />}
      {label}
    </Badge>
  );
}
